// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {
    small: `${pxToRem(1)} ${pxToRem(2)} ${pxToRem(9)} 0 ${safeColor(getColor("common.shadow"))
        .rgb()
        .alpha(0.2)
        .string()}`,
    main: `${pxToRem(1)} ${pxToRem(8)} ${pxToRem(12)} 0 ${safeColor(getColor("common.shadow"))
        .rgb()
        .alpha(0.37)
        .string()}`,
    alt: `${pxToRem(1)} ${pxToRem(3)} ${pxToRem(9)} 0 ${safeColor(getColor("common.shadow"))
        .rgb()
        .alpha(0.32)
        .string()}`,
    "2": `${pxToRem(1)} ${pxToRem(8)} ${pxToRem(12)} 0 ${safeColor(getColor("common.shadow"))
        .rgb()
        .alpha(0.37)
        .string()}`,
};

export default shadows;
